import ru from "vuetify/src/locale/ru";

export default {
  requests: {
    fio: "Ф.И.О.",
    iin: "ИИН",
    create: "Подать заявку на заключение договора",
    delete: "Удалить заявку",
    req_saved: "Заявка сохранена",
    req_signed: "Заявка подписана",
    plan_saved: "План поставок сохранен. Теперь можно отправить заявку на согласование.",
    delete_file: "Удалить",
    add_file: "Добавить",
    view: "Просмотреть договор",
    attachments: "Прикреплённые документы",
    edit: "Изменить заявку",
    supply: "Заполнить предварительную заявку о поставке электроэнергии",
    send: "Отправить на рассмотрение",
    req: "Дата подачи заявки",
    number: "Номер заявки",
    last_action: "Дата последнего изменения статуса заявки",
    status: "Текущий статус заявки",
    comment: "Комментарий ТОО «АлматыЭнергоСбыт»",
    contract: "Номер договора",
    region_name: "Регион",
    bank_name: "Банк",
    iik_number: "ИИК",
    ap_fact_address2: "Адрес объекта энергоснабжения",
    is_resident: "Резидент РК",
    assigned_power: "Установленная мощность",
    azhk_org_branch: "РЭС АО АЖК (указан в акте разграничения)",
    phone_number: "Контактный телефон",
    email: "Адрес электронной почты",
    org_type: "Организационно-правовая форма",
    contractor_name: "Наименование организации",
    contractor_jur_address2: "Юридический адрес (для ИП и физ.лиц указывается адрес по месту регистрации (прописки))",
    contractor_fact_address2: "Фактический адрес",
    boss_pos_name: "Должность руководителя",
    boss_fio: "Ф.И.О. руководителя",
    accept: "Согласен на обработку персональных данных",
    private: "Ответственность за достоверность предоставленных данных несет заявитель",
    save: "Сохранить",
    attach_type_name: "Тип документа",
    attach_file_name: "Имя файла",
    attach_file_type: "Тип файла",
    action: "Действие",
    send_supply:
      "Шаг 3. Заполнить предварительную заявку о поставке электроэнергии",
    send_supply2:
      "Заполнить предварительную заявку о поставке электроэнергии",
    send_supply_req: "Заявка о поставке электроэнергии",
    title_new: "Шаг 1. Заявка на заключение договора",
    title_attach: "Шаг 2. Добавьте документы",
    message_for_accept:
      "Уважаемый-ая {name}, следующие поля необходимо заполнять для подачи заявления об акцепте договора электроснабжения:",
    post_adres: "Почтовый адрес",
    phone_messages: "Сотовый номер для мессенджеров",
    phone_multimedia: "Сотовый номер для мультимедийного сообщения",
    phone_mobile: "Сотовый номер",
    email_accept: "Email",
    view_accept: "Посмотреть акцепт",
    view_request: "Посмотреть заявление",
    BIK: "БИК",
    sign_contract: "Подписать договор",
    kvt: "кВт.ч.",
    "invalid-phone": "Некорректный номер телефона",
  },
  $vuetify: ru,
  ru: "RU",
  kk: "KZ",
  hello: "Privet",
  attention: "Внимание",
  cancel: "Отмена",
  update: "Обновить",
  close: "Закрыть",
  "no-data": "Нет данных",
  back: "Назад",
  summary: "Итого",
  expand: "Развернуть",
  ui: {
    print: "Распечатать",
    labels: {
      yes: "Да",
      no: "Нет",
      close: "Закрыть",
    },
    wait: "Пожалуйста, подождите...",
    document_loading:
      "Ваш документ загружается и будет открыт в этом окне. Пожалуйста, подождите...",
    list_all: "Все",
    no_data_for_period: "Нет данных за выбранный период",
    "date-picker": {
      label: "Выберите период",
      from: "с",
      to: "по",
    },
    errors: {
      timeout:
        "Превышено количество пользователей.<br/>Пожалуйста, попробуйте позже",
    },
  },
  "update-checker": {
    message:
      'Доступна новая версия Личного кабинета.<br /><br /> Обновить? <br /><br />Нажмите "Обновить", чтобы перезагрузить страницу. Все введённые данные при этом будут утеряны.',
  },
  maintenance: {
    message:
      '<center><b>Внимание!</b> <span style="font-weight: 400"> <br /><br /> Ведутся технические работы. <br /><br /> Приносим извинения <br /> за доставленные неудобства.</span> </center>',
  },
  "app-header": {
    feedback: "Обратная связь",
    "contact-center": "Круглосуточный контакт-центр 356-99-99, 399-99-00",
    departments: "Районные отделения АлматыЭнергоСбыт (РОЭС)",
  },
  "app-navigation": {
    contract: "Договор",
    "contract-placeholder": "Выберите номер",
    bin: "БИН",
    organization: "Организация",
    "home-tooltip": "Список заявок",
    "profile-tooltip": "Профиль",
    "exit-tooltip": "Выход",
    "pay-tooltip": "Оплатить",
    "appeal-tooltip":
      "Мои обращения. Форма обратной связи для отправки предложений и обращений и получения ответов от ТОО «АлматыЭнергоСбыт»",
    contracts:
      "Общая информация о договоре: дата заключения, день предоставления показаний",
    abonent:
      "Здесь указаны ваши реквизиты: свидетельство о постановке на учет по НДС, информация о сотрудниках",
    points:
      "Информация об установленных приборах учета, пломбах  и трансформаторов тока, тарифы, ТП",
    calcs:
      "Просмотр информации по начислениям и оплатам в разрезе услуг и периодов",
    actions:
      "Передача показаний, получение и отправка Акта сверки и Акта выполненных работ",
    notices: "Просмотр уведомлений о задолженности",
    reports:
      "Просмотр документов: акты сверки взаиморасчетов, акты выполненных работ, счета на оплату, приложение 2",
    invoices: "Просмотр счетов-фактур",
  },
  "app-menu": {
    "debt-button": "Задолженность по договору",
    contract: "Договор",
    abonent: "Потребитель",
    "accounting-points": "Точки учета",
    payments: "Начисление и оплата",
    "report-forms": "Отчетные формы",
    actions: "Действия по договору",
    "debt-notifications": "Уведомления <br /> о задолженности",
    invoices: "Счета-фактуры",
  },
  "app-footer": {
    text: "АлматыЭнергоСбыт. Разработано АО «АЛСЕКО»",
  },
  "auth-view": {
    title: "Заявки",
    enter: "Вход",
    form: {
      title: "Вход без ЭЦП",
      "enter-bin": "Введите БИН",
      "enter-iin": "Введите ИИН",
      "credentials-title": "Выберите полномочия",
    },
    "form-eds": {
      title: "Войти с ЭЦП",
    },
    manuals: {
      "video-inctruction": {
        title: "Посмотреть видеоинструкцию работы личного кабинета",
        href: "https://esalmaty.kz/ru/i3398",
      },
      "get-eds": {
        title: "Получение ЭЦП для юридических лиц",
        href: "https://egov.kz/cms/ru/information/eds/getecpiio",
      },
    },
  },
  credentials: {
    individual: "Физическое Лицо",
    legal: "Юридическое лицо",
    "first-leader":
      "Первый руководитель юридического лица, имеющий право подписи",
    signer: "Лицо, наделенное правом подписи",
    "financial-signer": "Лицо, наделенное правом подписи финансовых документов",
    hr:
      "Сотрудник отдела кадров, наделенный правом подтверждать заявки на выпуск регистрационных свидетельств поданные от сотрудников юридического лица",
    employee: "Сотрудник организации",
  },
  "form-validator": {
    required: "Поле, обязательное для заполнения",
    "string-max": "Максимальная длина строки {max} символов",
    "string-min": "Минимальная длина строки {min} символов",
    bin: "Неверный формат БИН",
    iin: "Неверный формат ИИН",
    email: "Введён некорректный email",
    number: "Введено некорректное число",
  },
  storages: {
    computer: "Ваш Компьютер",
    "kaz-token": "Казтокен",
    "id-card": "Личное удостоверение",
    "e-token": "EToken Java 72k",
    "ak-ja-carta": "AK JaCarta",
  },
  eds: {
    sign: "Подписать",
    reject: "Отклонить",
    "sign-with-eds": "Подписать с ЭЦП",
    error:
      "Для работы с ключами электронной цифровой подписи установите или запустите программу NCALayer",
  },
  profile: {
    title: "Профиль",
    organization: {
      title: "Данные об организации",
      "bin-iin": "БИН/ИИН",
      name: "Наименование",
      email: {
        title: "Email",
        placeholder: "Введите email",
        edit: "Редактировать  email",
        save: "Сохранить email",
        cancel: "Отменить изменение email",
        "not-verified": "Ваш email не подтвержден",
        "card-no-email":
          "Электронный адрес не введен. Для использования всех возможностей Личного кабинета введите и подтвердите Ваш электронный адрес",
        "card-title": "Подтверждение email",
        "card-not-verified":
          "Ваш электронный адрес{email} не подтвержден.<br />Для использования всех возможностей Личного кабинета необходимо подтвердить электронный адрес",
        "card-link": "Переотправить ссылку для подтверждения",
        "card-text-send":
          "На Ваш электронный адрес {email} было отправлено письмо с ссылкой для подтверждения email.",
        "card-text-confirm": "Ваш электронный адрес успешно подтвержден",
      },
    },
  },
  contracts: {
    number: "Договор",
    date: "Дата заключения",
    region: "Регион",
    list: "Список договоров",
    empty: "Нет действующих договоров",
  },
};
